import React from 'react'

import { Navigate } from 'react-router-dom'
import logger from '../utils/log-util'

const DeprecatedRoutes = ({ newPath, params }) => {
  logger.info(`Trying to access a deprecated route. Redirecting to: ${newPath}`)

  return <Navigate to={newPath} state={params} replace={true} />
}

export default DeprecatedRoutes
